import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GestionStocksRoutingModule} from './gestion-stocks-routing.module';

import {GestionStocksRootComponent} from './gestion-stocks-root.component';
import {StocksComponent} from './stocks/stocks.component';
import {InventaireComponent} from './stocks/inventaire/inventaire.component';
import {SharedModule} from '../shared/shared.module';
import {SearchPanelComponent} from './stocks/search-panel/search-panel.component';
import {MatieresPremieresComponent} from './stocks/matieres-premieres/matieres-premieres.component';
import {LotsComponent} from './stocks/matieres-premieres/lots/lots.component';
import {DialogPerimesComponent} from './stocks/matieres-premieres/dialog-perimes/dialog-perimes.component';
import {MouvementsComponent} from './mouvements/mouvements.component';
import {DialogSortieComponent} from './stocks/matieres-premieres/dialog-sortie/dialog-sortie.component';
import {DialogModificationMouvementComponent} from './mouvements/dialog-modification-mouvement/dialog-modification-mouvement.component';
import {SearchPanelMouvementsComponent} from './mouvements/search-panel-mouvements/search-panel-mouvements.component';
import {GrilleMouvementsComponent} from './mouvements/grille-mouvements/grille-mouvements.component';
import {DialogPrintInventaireComponent} from './stocks/inventaire/dialog-print-inventaire/dialog-print-inventaire.component';
import {PrintInventaireService} from '../core/services/gestion-stock/print-inventaire.service';
import {DialogModificationLotsComponent} from './stocks/matieres-premieres/lots/dialog-modification-lots/dialog-modification-lots.component';
import {CoreModule} from '../core/core.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CardModule} from 'primeng/card';
import {TableModule} from 'primeng/table';
import {CheckboxModule} from 'primeng/checkbox';
import {PanelModule} from 'primeng/panel';
import {ListboxModule} from 'primeng/listbox';
import {TabMenuModule} from 'primeng/tabmenu';
import {DialogModule} from 'primeng/dialog';

import {CalendarModule} from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import {RadioButtonModule} from 'primeng/radiobutton';
import {DialogLotAjoutComponent} from "./stocks/matieres-premieres/dialog-lot-ajout/dialog-lot-ajout.component";
import {
  DevExtremeModule,
  DxAccordionModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxListModule,
  DxPopupModule,
  DxRadioGroupModule,
  DxToolbarModule,
  DxTreeViewModule
} from "devextreme-angular";
import {DxoPagerModule} from "devextreme-angular/ui/nested";
import {NgxPaginationModule} from "ngx-pagination";

@NgModule({
  declarations: [
    GestionStocksRootComponent,
    StocksComponent,
    InventaireComponent,
    SearchPanelComponent,
    MatieresPremieresComponent,
    LotsComponent,
    DialogPerimesComponent,
    MouvementsComponent,
    DialogSortieComponent,
    DialogModificationMouvementComponent,
    SearchPanelMouvementsComponent,
    GrilleMouvementsComponent,
    DialogPrintInventaireComponent,
    DialogModificationLotsComponent,
    DialogLotAjoutComponent
  ],
    imports: [
        CommonModule,
        GestionStocksRoutingModule,
        SharedModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,

        CardModule,
        TableModule,
        CheckboxModule,
        PanelModule,
        ListboxModule,
        TabMenuModule,
        DialogModule,

        CalendarModule,
        DropdownModule,
        RadioButtonModule,
        DxDataGridModule,
        DxoPagerModule,
        DxRadioGroupModule,
        DxTreeViewModule,
        DxDropDownBoxModule,
        DxListModule,
        DxCheckBoxModule,
        DxPopupModule,
        DxToolbarModule,
        DxDateBoxModule,
        DxAccordionModule,
        NgxPaginationModule,
        DevExtremeModule,
    ],
  providers: [
    PrintInventaireService
  ]
})
export class GestionStocksModule { }
